export function normalizeSearchText(value) {
  return normalizeSearchValue(value).text
}

export function normalizeSearchTextWithMap(value) {
  return normalizeSearchValue(value, true)
}

export function normalizeSearchNode(element) {
  const document = element.ownerDocument
  const nodeFilter = document.defaultView?.NodeFilter || window.NodeFilter
  const walker = document.createTreeWalker(element, nodeFilter.SHOW_TEXT, {
    acceptNode: (node) => node.parentElement?.closest("script, style") ? nodeFilter.FILTER_REJECT : nodeFilter.FILTER_ACCEPT
  })
  const normalized = { text: "", map: [] }
  let node

  while ((node = walker.nextNode())) appendNormalizedText(normalized, node.nodeValue, node)

  trimTrailingSpace(normalized)
  return normalized
}

function normalizeSearchValue(value, includeMap = false) {
  const normalized = { text: "", map: includeMap ? [] : null }
  appendNormalizedText(normalized, value)
  trimTrailingSpace(normalized)
  return normalized
}

function appendNormalizedText(normalized, value, node = null) {
  let offset = 0

  for (const character of Array.from(value || "")) {
    for (const token of normalizedTokens(character)) {
      if (token === " " && (normalized.text.length === 0 || normalized.text.endsWith(" "))) continue

      normalized.text += token
      if (normalized.map) {
        const position = { startOffset: offset, endOffset: offset + character.length }
        if (node) position.node = node
        normalized.map.push(position)
      }
    }
    offset += character.length
  }
}

function trimTrailingSpace(normalized) {
  if (!normalized.text.endsWith(" ")) return

  normalized.text = normalized.text.slice(0, -1)
  normalized.map?.pop()
}

function normalizedTokens(character) {
  const normalized = character.normalize("NFD").replace(/\p{Mark}/gu, "").toLocaleLowerCase()
  return Array.from(normalized).map((token) => /[\p{Letter}\p{Number}]/u.test(token) ? token : " ")
}
